import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UiProfileService } from 'BI-Libraries/BI-Components/dist/bi-modules';

@Component({
  selector: 'screens-list',
  standalone: false,
  templateUrl: './screens-list.component.html',
  styleUrl: '../home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScreensListComponent {
  @Input() Items: {ItemName:string, Path:string, Parent:string}[] = [];
  @Input() ShowDeleteButton: boolean = true;
  @Input() Title: string = '';
  @Input() IconPath: string = '';

  constructor(
    private router: Router,
    @Inject('UIUserProfile') private uiProfileService,

  ){
  }

  DeleteItem(itemIndex: number, itemUrl: string){
    if (this.ShowDeleteButton) {
      this.Items.splice(itemIndex, 1);
      this.uiProfileService.emitfavoriteScreenChanged(false,itemUrl);
    }
  }

  navigateTo(path: string): void {
    this.router.navigate([path]);
  }
}
